import React, { useState, useEffect } from 'react';
import NavigationBar from '../components/NavigationBar';
import TIMELINE from '../data/timeline.json';
import './History.css';

const History = () => {
  const [activeEntry, setActiveEntry] = useState(null);

  // Schliessen mit Escape-Taste
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') setActiveEntry(null);
    };
    if (activeEntry) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [activeEntry]);

  return (
    <>
      <NavigationBar />

      <div className="history-page">
        <header className="history-header">
          <h1>Historie des Rosa-Luxemburg-Platzes</h1>
          <p className="history-lede">
            Vom Scheunenviertel ueber den Buelowplatz und Horst-Wessel-Platz zum
            Rosa-Luxemburg-Platz - drei Jahrhunderte Berliner Geschichte an einem Ort.
          </p>
        </header>

        <ol className="timeline">
          {TIMELINE.map((entry, i) => (
            <li key={i} className="timeline-item">
              <span className="timeline-year">{entry.year}</span>
              <div className="timeline-content">
                <h2>{entry.title}</h2>
                <p>
                  {entry.body}
                  {entry.detail && (
                    <>
                      {' '}
                      <button
                        className="weiterlesen-btn"
                        onClick={() => setActiveEntry(entry)}
                      >
                        Weiterlesen&nbsp;…
                      </button>
                    </>
                  )}
                </p>
              </div>
            </li>
          ))}
        </ol>

        <footer className="history-footer">
          <p>
            Quellen: kuratierte Recherche aus oeffentlichen Archiven, OpenStreetMap,
            Stadtgeschichte Berlin-Mitte. Die zugehoerigen Orte (Volksbuehne, Babylon,
            Karl-Liebknecht-Haus &hellip;) sind in der Karte verortet.
          </p>
        </footer>
      </div>

      {/* Modal */}
      {activeEntry && (
        <div
          className="detail-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) setActiveEntry(null); }}
        >
          <div className="detail-panel">
            <button
              className="detail-close"
              onClick={() => setActiveEntry(null)}
              aria-label="Schliessen"
            >
              ✕
            </button>
            <span className="detail-year">{activeEntry.year}</span>
            <h2 className="detail-title">{activeEntry.title}</h2>
            {activeEntry.image && (
              <figure className="detail-figure">
                <img
                  src={activeEntry.image}
                  alt={activeEntry.imageCaption || activeEntry.title}
                  className="detail-img"
                />
                {activeEntry.imageCaption && (
                  <figcaption className="detail-caption">{activeEntry.imageCaption}</figcaption>
                )}
              </figure>
            )}
            <div className="detail-body">
              {activeEntry.detail.split('\n').map((para, i) =>
                para.trim() ? <p key={i}>{para}</p> : null
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default History;
